// extracted by mini-css-extract-plugin
module.exports = {"app-link":"AppLink_app-link__3Exjq"};